export class BeanConfirmationDialog{
    constructor(      
      public  dialogTitle :string,
      public  dialogText :string,
    ){}
  }